import { Typography, Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

const items = [
  '✅ 独家技巧, 工作效率提升200%',
  '✅ 3天速成, Excel萌新变高手',
  '✅ 4步透视表, 数据分析真简单',
];

// ✅ 自定义 Hook：监听是否进入可视区域
function useInView(options = {}) {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(([entry]) => {
        setInView(entry.isIntersecting);
      }, options);
  
      if (ref.current) {
        observer.observe(ref.current);
      }
  
      return () => observer.disconnect();
    }, [ref, options]);
  
    return [ref, inView];
  }

export default function AnimatedTextList() {
    const [ref, inView] = useInView({ threshold: 0.3 });
    return (
     <div ref={ref}>
        <style>{`
            @keyframes slideInLeft {
            0% {
                transform: translateX(-50px);
                opacity: 0;
            }
            100% {
                transform: translateX(0);
                opacity: 1;
            }
            }
        `}</style>
            <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    flexWrap: 'wrap',
                    flexDirection: 'column',
                    gap: 10 }}>
                {items.map((text, index) => (
                    <Typography
                    key={index}
                    variant="h5"
                    sx={{
                        fontFamily: '"ZCOOL KuaiLe", sans-serif',
                        fontStyle: 'normal',
                        mb: 1,
                        opacity: 0, // 初始隐藏
                        animation: inView ? `slideInLeft 0.6s ease-out forwards` : 'none',
                        animationDelay: inView ? `${index * 0.3}s` : '0s', // 依次延迟
                    }}
                    >
                    {text}
                    </Typography>
                ))}
        </Box>
        </div>
        );
    }
